/**
 * External dependencies.
 */
import Image from "next/image";

/**
 * Internal dependencies.
 */
import { getStrapiMedia } from "utils";
import { MediaProp } from "types";
import Markdown from "components/markdown/markdown";

interface GridBoxesProp {
  boxes: {
    Title?: string;
    Content?: string;
    Image?: MediaProp;
  }[];
}

const GridBoxes: React.FC<GridBoxesProp> = ({ boxes }) => {
  const columns = Math.max(boxes.length, 1);
  // Match container gutters, inter-card gaps and borders; mobile cards are fixed.
  const tabletGutters = 70 + (columns - 1) * 20 + columns * 2;
  const desktopGutters = 112 + (columns - 1) * 40 + columns * 2;
  const sizes = `(max-width: 767px) 278px, (max-width: 1023px) calc((100vw - ${tabletGutters}px) / ${columns}), (max-width: 1440px) calc((100vw - ${desktopGutters}px) / ${columns}), ${(1440 - desktopGutters) / columns}px`;

  return (
  <div className="grid-boxes">
    <div className="container">
      <div className="grid-boxes__inner">
        {boxes.map((item: any, index) => (
          <div className="grid-box" key={`grid-box-${index}`}>
            {item.Media && item.Media.data && (
              <Image
                alt=""
                src={getStrapiMedia(item.Media)}
                width={item.Media.data.attributes.width}
                height={item.Media.data.attributes.height}
                sizes={sizes}
              />
            )}

            <div className="grid-box__content">
              <div className="grid-box__title">{item.Title}</div>
              <Markdown content={item.Content} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
  );
};

export default GridBoxes;
